import { Button, makeStyles } from '@fluentui/react-components';
import { ChevronDownRegular, ChevronRightRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useStores } from '../../../common/hooks';
import { AdditionalContactDetailForm } from './AdditionalContactDetailForm';
import { CompanyInformationDetailForm } from './CompanyInformationDetailForm';
import { JointNomineesDetailForm } from './JointNomineesDetailForm';
import './NominationDetails.scss';
import { NominationNameDetailForm } from './NominationNameDetailForm';
import { SummaryLayout } from './SummaryLayout';

const useStyles = makeStyles({
  expandableTriggerButton: { padding: 0, color: '#000000', justifyContent: 'flex-start' }
});

const NominationDetailsImpl: React.FC = () => {
  const {
    nominationForStaffPageUiStore,
  } = useStores();

  const styles = useStyles();

  const [isNominationDetailsExpanded, setNominationDetailsExpanded] = useState<boolean>(true);

  const renderNominationDetails = (): React.JSX.Element => {
    return (
      <>
        <SummaryLayout withTopBorder>
          <NominationNameDetailForm
            isViewOnly={!nominationForStaffPageUiStore.isEditingMode}
          />
        </SummaryLayout>
        <SummaryLayout withTopBorder>
          <CompanyInformationDetailForm
            isViewOnly={!nominationForStaffPageUiStore.isEditingMode}
          />
        </SummaryLayout>
        <SummaryLayout withTopBorder>
          <AdditionalContactDetailForm
            isViewOnly={!nominationForStaffPageUiStore.isEditingMode}
          />
        </SummaryLayout>
        <SummaryLayout withTopBorder>
          <JointNomineesDetailForm
            isViewOnly={!nominationForStaffPageUiStore.isEditingMode}
          />
        </SummaryLayout>
      </>
    );
  };

  return (
    <div
      className='nomination-details'
    >
      <SummaryLayout
        title={<Button
          appearance='transparent'
          onClick={() => setNominationDetailsExpanded(!isNominationDetailsExpanded)}
          aria-expanded={isNominationDetailsExpanded}
          icon={isNominationDetailsExpanded ? <ChevronDownRegular /> : <ChevronRightRegular />}
          iconPosition='after'
          className={styles.expandableTriggerButton}
        >
          Nomination details
        </Button>}
      />
      {
        isNominationDetailsExpanded && renderNominationDetails()
      };
    </div>
  );
}

export const NominationDetails = observer(NominationDetailsImpl);
